import React, { useState, useEffect, useId } from 'react';
import { useSelector } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Button, Icon, ModalIsland, ButtonIcon } from '@saviynt/design-system';
import classnames from 'classnames';
import { checkEnvironment } from 'ui-common/src/lib/utils';
import RequestingForDropdown from './RequestingForDropdown';

import './RequestAccessModal.scss';

const ICON_COLOR_ACTIVE = '#00245B';
const ICON_COLOR_DISABLED = '#6d7085';

export const Close = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.62204 8.62204C8.78476 8.45932 9.04858 8.45932 9.21129 8.62204L16 15.4107L22.7887 8.62209C22.9514 8.45937 23.2152 8.45937 23.378 8.62209C23.5407 8.78481 23.5407 9.04862 23.3779 9.21134L16.5893 16L23.3779 22.7887C23.5407 22.9514 23.5407 23.2152 23.378 23.3779C23.2152 23.5406 22.9514 23.5406 22.7887 23.3779L16 16.5893L9.21129 23.378C9.04858 23.5407 8.78476 23.5407 8.62204 23.378C8.45932 23.2152 8.45932 22.9514 8.62204 22.7887L15.4108 16L8.62204 9.21129C8.45932 9.04858 8.45932 8.78476 8.62204 8.62204Z"
      fill="#212328"
    />
  </svg>
);

export const StartAccessModal = () => (
  <svg
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M30.0667 4.76719C26.3228 4.76719 23.2877 7.80228 23.2877 11.5463V18.155C25.3764 17.2912 27.666 16.8146 30.0668 16.8146C39.8711 16.8146 47.8191 24.7626 47.8191 34.567C47.8191 35.1469 47.349 35.6171 46.769 35.6171C46.1891 35.6171 45.7189 35.1469 45.7189 34.567C45.7189 25.9225 38.7112 18.9148 30.0668 18.9148C21.4223 18.9148 14.4146 25.9225 14.4146 34.567C14.4146 42.5933 20.457 49.2099 28.2404 50.1138C28.8165 50.1807 29.2293 50.7019 29.1624 51.278C29.0955 51.8541 28.5743 52.2669 27.9982 52.2C19.168 51.1746 12.3145 43.6719 12.3145 34.567C12.3145 27.9964 15.8841 22.2596 21.1898 19.1901C21.1883 19.1666 21.1875 19.1429 21.1875 19.1191V11.5463C21.1875 6.64238 25.1629 2.66699 30.0667 2.66699C34.9706 2.66699 38.946 6.64238 38.946 11.5463C38.946 12.1262 38.4759 12.5964 37.8959 12.5964C37.316 12.5964 36.8458 12.1262 36.8458 11.5463C36.8458 7.80228 33.8107 4.76719 30.0667 4.76719Z"
      fill="#FC3DA6"
    />
    <path
      d="M23.8096 34.5669C23.8096 31.1112 26.6111 28.3098 30.0668 28.3098C33.5225 28.3098 36.3239 31.1112 36.3239 34.5669C36.3239 35.1469 36.794 35.617 37.374 35.617C37.954 35.617 38.4241 35.1469 38.4241 34.5669C38.4241 29.9513 34.6824 26.2096 30.0668 26.2096C25.4511 26.2096 21.7094 29.9513 21.7094 34.5669C21.7094 37.8426 23.5942 40.6762 26.3336 42.0459C26.8523 42.3053 27.4831 42.095 27.7425 41.5763C28.0018 41.0576 27.7916 40.4268 27.2728 40.1674C25.2174 39.1397 23.8096 37.0168 23.8096 34.5669Z"
      fill="#FC3DA6"
    />
    <path
      d="M22.5304 24.0302C22.3842 24.1568 22.3684 24.3779 22.495 24.524C22.6216 24.6701 22.8426 24.6859 22.9887 24.5594C23.3936 24.2086 23.8219 23.8913 24.2692 23.6086C24.4327 23.5053 24.4814 23.2891 24.3781 23.1257C24.2749 22.9623 24.0587 22.9135 23.8952 23.0168C23.4185 23.3181 22.962 23.6563 22.5304 24.0302Z"
      fill="#FC3DA6"
    />
    <path
      d="M25.2826 22.2691C25.1064 22.3489 25.0283 22.5563 25.1081 22.7324C25.1878 22.9085 25.3952 22.9866 25.5713 22.9069C28.604 21.5338 32.2302 21.5935 35.332 23.3843C36.1269 23.8432 36.8402 24.3885 37.4671 25.0014C37.6053 25.1365 37.8269 25.134 37.962 24.9958C38.0972 24.8575 38.0947 24.6359 37.9564 24.5008C37.2881 23.8474 36.5281 23.2664 35.6821 22.778C32.3766 20.8696 28.512 20.807 25.2826 22.2691Z"
      fill="#FC3DA6"
    />
    <path
      d="M39.0272 25.7088C38.9097 25.5554 38.6899 25.5263 38.5365 25.6439C38.383 25.7614 38.354 25.9812 38.4715 26.1346C38.6319 26.344 38.784 26.5586 38.9277 26.7781C39.0336 26.9398 39.2505 26.9851 39.4123 26.8792C39.574 26.7734 39.6193 26.5564 39.5134 26.3947C39.3603 26.1608 39.1982 25.932 39.0272 25.7088Z"
      fill="#FC3DA6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.5972 40.3049C47.3109 39.3155 49.4903 39.8633 50.5388 41.5204C50.839 41.0842 51.2387 40.7063 51.7278 40.4239C53.4798 39.4124 55.7186 40.0075 56.738 41.7522C56.7426 41.7599 56.7472 41.7677 56.7517 41.7756L56.7583 41.7874L63.0611 53.2283C63.6576 54.3111 63.9405 55.5386 63.8781 56.7733L63.7658 58.9932C63.7479 59.3484 63.8385 59.7006 64.0257 60.0029L68.5278 67.2737C68.6773 67.5152 68.7226 67.8071 68.6533 68.0826C68.584 68.3581 68.4061 68.5938 68.16 68.7359L53.5122 77.1928C53.0226 77.4755 52.3971 77.3198 52.0971 76.8407L48.3245 70.8153C48.109 70.4712 47.7806 70.2127 47.3955 70.0841L40.1517 67.6648C38.5564 67.132 37.2221 66.0144 36.4177 64.5373L32.721 57.7486C31.9825 56.3926 32.1256 54.7265 33.0845 53.5162L34.8774 51.2532L27.2623 36.8959C26.2617 35.1409 26.8657 32.905 28.6175 31.8936C30.3752 30.8788 32.6227 31.481 33.6375 33.2387L39.4 43.2196C39.7 42.7847 40.0989 42.408 40.5869 42.1262C41.6955 41.4862 42.999 41.4894 44.0652 42.0201C44.368 41.3233 44.8887 40.714 45.5972 40.3049ZM39.3585 59.7019C39.6303 60.2142 40.2659 60.4092 40.7783 60.1375C41.2906 59.8657 41.4856 59.2301 41.2139 58.7178L29.1007 35.8799L29.0912 35.8635C28.6564 35.1104 28.9144 34.1473 29.6676 33.7124C30.4208 33.2776 31.3839 33.5356 31.8187 34.2888L39.1593 47.0031C39.1686 47.0193 39.1784 47.0351 39.1884 47.0506C39.2057 47.0827 39.2235 47.1145 39.2418 47.1463C39.5318 47.6485 40.174 47.8206 40.6763 47.5306C41.1785 47.2406 41.3506 46.5984 41.0606 46.0962C40.6258 45.343 40.8838 44.3799 41.637 43.9451C42.3902 43.5102 43.3533 43.7683 43.7881 44.5214L44.168 45.1795C44.1779 45.1966 44.1882 45.2134 44.1989 45.2298C44.2161 45.2616 44.2338 45.2934 44.2521 45.325C44.542 45.8272 45.1843 45.9993 45.6865 45.7093C46.1888 45.4193 46.3609 44.7771 46.0709 44.2749C45.636 43.5217 45.8941 42.5586 46.6473 42.1238C47.4004 41.6889 48.3635 41.947 48.7984 42.7001L50.3825 45.4439C50.5394 45.7157 50.7994 45.8908 51.0846 45.9483C51.3265 45.9972 51.5866 45.9614 51.8171 45.8283C52.3194 45.5383 52.4915 44.8961 52.2015 44.3938C51.7666 43.6407 52.0247 42.6776 52.7779 42.2427C53.5298 41.8086 54.4911 42.0651 54.9269 42.8155L61.2216 54.2417C61.6297 54.9825 61.8233 55.8225 61.7806 56.6672L61.6683 58.8871C61.6288 59.6685 61.8283 60.4434 62.2401 61.1086L62.5295 61.5759L49.5891 69.0471C49.1651 68.6151 48.6423 68.2862 48.0608 68.092L40.817 65.6727C39.7255 65.3082 38.8126 64.5436 38.2622 63.5329L34.5654 56.7442C34.2298 56.1278 34.2948 55.3705 34.7307 54.8204L35.9518 53.279L39.3585 59.7019ZM50.7823 70.7832L53.3395 74.8674L66.172 67.4585L65.5574 66.4659L59.5891 69.9117C59.4217 70.0084 59.2076 69.951 59.111 69.7836C59.0143 69.6162 59.0717 69.4021 59.2391 69.3055L65.1887 65.8704L64.619 64.9505L60.1037 67.5574C59.9363 67.654 59.7222 67.5967 59.6256 67.4293C59.5289 67.2618 59.5863 67.0478 59.7537 66.9511L64.2503 64.355L63.6357 63.3623L50.7823 70.7832Z"
      fill="#00245B"
    />
  </svg>
);

export const ApplicationCollection = ({ style }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7778 6.94434C11.7039 6.94434 10.8333 7.81489 10.8333 8.88878V31.111C10.8333 32.1849 11.7039 33.0554 12.7778 33.0554H27.2222C28.2961 33.0554 29.1667 32.1849 29.1667 31.111V8.88878C29.1667 7.81489 28.2961 6.94434 27.2222 6.94434H12.7778ZM12.5 8.88878C12.5 8.73537 12.6244 8.611 12.7778 8.611H27.2222C27.3756 8.611 27.5 8.73537 27.5 8.88878V31.111C27.5 31.2644 27.3756 31.3888 27.2222 31.3888H12.7778C12.6244 31.3888 12.5 31.2644 12.5 31.111V8.88878Z"
      fill={style.color}
    />
    <path
      d="M5 27.2221C5 28.296 5.87056 29.1666 6.94444 29.1666H9.72222V27.4999H6.94444C6.79103 27.4999 6.66667 27.3755 6.66667 27.2221L6.66667 12.7777C6.66667 12.6243 6.79103 12.4999 6.94444 12.4999H9.72222V10.8332H6.94444C5.87056 10.8332 5 11.7038 5 12.7777V27.2221Z"
      fill={style.color}
    />
    <path
      d="M33.0556 27.4999H30.2778V29.1666H33.0556C34.1294 29.1666 35 28.296 35 27.2221V12.7777C35 11.7038 34.1294 10.8332 33.0556 10.8332H30.2778V12.4999H33.0556C33.209 12.4999 33.3333 12.6243 33.3333 12.7777V27.2221C33.3333 27.3755 33.209 27.4999 33.0556 27.4999Z"
      fill={style.color}
    />
  </svg>
);

export const PrivilegedAccess = ({ style }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7483 6.29943C20.6083 6.01395 20.318 5.83301 20 5.83301C19.6821 5.83301 19.3918 6.01395 19.2518 6.29943L13.7583 17.502L6.40786 10.5071C6.14633 10.2582 5.75429 10.2061 5.43677 10.3779C5.11926 10.5497 4.9485 10.9064 5.01379 11.2615L8.28302 29.0391C8.35575 29.4345 8.70051 29.7217 9.10261 29.7217H30.8975C31.2996 29.7217 31.6443 29.4345 31.7171 29.0391L34.9863 11.2615C35.0516 10.9064 34.8808 10.5497 34.5633 10.3779C34.2458 10.2061 33.8538 10.2582 33.5922 10.5071L26.2418 17.502L20.7483 6.29943ZM14.7547 19.2555L20 8.55902L25.2454 19.2555C25.3623 19.4937 25.5856 19.6621 25.8468 19.7089C26.108 19.7556 26.3759 19.6752 26.5681 19.4922L32.8833 13.4825L30.2034 28.055H9.79667L7.11685 13.4825L13.432 19.4922C13.6242 19.6752 13.8921 19.7556 14.1533 19.7089C14.4145 19.6621 14.6378 19.4937 14.7547 19.2555Z"
      fill={style.color}
    />
    <path
      d="M9.1027 32.4997C8.64246 32.4997 8.26936 32.8728 8.26936 33.333C8.26936 33.7932 8.64246 34.1663 9.1027 34.1663H30.8976C31.3578 34.1663 31.7309 33.7932 31.7309 33.333C31.7309 32.8728 31.3578 32.4997 30.8976 32.4997H9.1027Z"
      fill={style.color}
    />
  </svg>
);

export const Role = ({ style }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1146 6.38867C17.1995 6.38867 14.8363 8.75186 14.8363 11.667C14.8363 14.5821 17.1995 16.9453 20.1146 16.9453C23.0297 16.9453 25.3929 14.5821 25.3929 11.667C25.3929 8.75186 23.0297 6.38867 20.1146 6.38867ZM16.5029 11.667C16.5029 9.67233 18.1199 8.05534 20.1146 8.05534C22.1093 8.05534 23.7263 9.67233 23.7263 11.667C23.7263 13.6617 22.1093 15.2787 20.1146 15.2787C18.1199 15.2787 16.5029 13.6617 16.5029 11.667Z"
      fill={style.color}
    />
    <path
      d="M13.3979 21.3037C17.4658 18.8803 22.5344 18.8803 26.6022 21.3037C27.3893 21.7726 27.8715 22.6212 27.8715 23.5373V32.7776C27.8715 33.2378 28.2446 33.6109 28.7049 33.6109C29.1651 33.6109 29.5382 33.2378 29.5382 32.7776V23.5373C29.5382 22.0339 28.7469 20.6414 27.4553 19.8719C26.9234 19.555 26.3763 19.2748 25.8176 19.0314C27.9825 17.8004 30.6462 17.8238 32.792 19.1016C33.1277 19.3015 33.3333 19.6633 33.3333 20.054V27.498C33.3333 27.9583 33.7064 28.3314 34.1667 28.3314C34.6269 28.3314 35 27.9583 35 27.498V20.054C35 19.0759 34.4851 18.1701 33.6448 17.6696C30.9334 16.055 27.5555 16.055 24.8441 17.6696L23.8959 18.2343C23.854 18.2592 23.8151 18.2873 23.7793 18.3179C21.3038 17.6531 18.6929 17.6534 16.2175 18.3188C16.1814 18.2879 16.1422 18.2596 16.1 18.2344L15.1526 17.67C12.4421 16.0552 9.06474 16.0552 6.35419 17.67C5.51445 18.1703 5 19.0756 5 20.0531V27.498C5 27.9583 5.3731 28.3314 5.83333 28.3314C6.29357 28.3314 6.66667 27.9583 6.66667 27.498V20.0531C6.66667 19.6629 6.87201 19.3015 7.2072 19.1019C9.35256 17.8238 12.0161 17.8006 14.1803 19.0323C13.6224 19.2756 13.0761 19.5554 12.5449 19.8719C11.2533 20.6414 10.462 22.0339 10.462 23.5373V32.7776C10.462 33.2378 10.8351 33.6109 11.2953 33.6109C11.7555 33.6109 12.1286 33.2378 12.1286 32.7776V23.5373C12.1286 22.6212 12.6108 21.7726 13.3979 21.3037Z"
      fill={style.color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.47233 12.2328C7.47233 10.385 8.97026 8.88704 10.818 8.88704C12.6658 8.88704 14.1638 10.385 14.1638 12.2328C14.1638 14.0806 12.6658 15.5785 10.818 15.5785C8.97026 15.5785 7.47233 14.0806 7.47233 12.2328ZM10.818 10.5537C9.89073 10.5537 9.139 11.3054 9.139 12.2328C9.139 13.1601 9.89073 13.9118 10.818 13.9118C11.7454 13.9118 12.4971 13.1601 12.4971 12.2328C12.4971 11.3054 11.7454 10.5537 10.818 10.5537Z"
      fill={style.color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.5266 12.2328C32.5266 10.3846 31.0279 8.88704 29.1798 8.88704C27.3318 8.88704 25.833 10.3846 25.833 12.2328C25.833 14.0809 27.3318 15.5785 29.1798 15.5785C31.0279 15.5785 32.5266 14.0809 32.5266 12.2328ZM29.1798 10.5537C30.1081 10.5537 30.8599 11.3058 30.8599 12.2328C30.8599 13.1597 30.1081 13.9118 29.1798 13.9118C28.2516 13.9118 27.4997 13.1597 27.4997 12.2328C27.4997 11.3058 28.2516 10.5537 29.1798 10.5537Z"
      fill={style.color}
    />
  </svg>
);

// Mobile width breakpoint for drawer behavior (320px for WCAG 1.4.10 compliance)
const MOBILE_BREAKPOINT = 480;

const getAccessButtonTitle = (intl, type) => {
  switch (type) {
    case 'application':
      return intl.formatMessage({
        id: 'NewRequestHome.QuickLink.AccessModal.RequestingTo.Application.ButtonLabel',
        defaultMessage: 'Start Application Request',
      });
    case 'role':
      return intl.formatMessage({
        id: 'NewRequestHome.QuickLink.AccessModal.RequestingTo.Role.ButtonLabel',
        defaultMessage: 'Start Enterprise Role Request',
      });
    case 'privilegedSession':
      return intl.formatMessage({
        id: 'NewRequestHome.QuickLink.AccessModal.RequestingTo.PrivilegedSession.ButtonLabel',
        defaultMessage: 'Start Privileged Session Request',
      });
    default:
      return null;
  }
};

const renderAccessDetails = (intl, type, isAccessible) => {
  const iconColor = isAccessible ? ICON_COLOR_ACTIVE : ICON_COLOR_DISABLED;

  switch (true) {
    case type === 'application':
      return (
        <>
          <span className="request-icon">
            <ApplicationCollection style={{ color: iconColor }} />
          </span>
          <div className="request-title">
            {intl.formatMessage({
              id: 'NewRequestHome.QuickLink.AccessModal.RequestingTo.Application.Label',
            })}
          </div>
        </>
      );
    case type === 'role':
      return (
        <>
          <span className="request-icon">
            <Role style={{ color: iconColor }} />
          </span>
          <div className="request-title">
            {intl.formatMessage({
              id: 'NewRequestHome.QuickLink.AccessModal.RequestingTo.Role.Label',
            })}
          </div>
        </>
      );
    case type === 'privilegedSession':
      return (
        <>
          <span className="request-icon">
            <PrivilegedAccess style={{ color: iconColor }} />
          </span>
          <div className="request-title">
            {intl.formatMessage({
              id: 'NewRequestHome.QuickLink.AccessModal.RequestingTo.PrivilegedSession.Label',
            })}
          </div>
        </>
      );
    default:
      return null;
  }
};

const RequestAccessModal = ({ onDialogClose, open, username, isPamEnabled, pamTileId }) => {
  const [requestTiles, setRequestTiles] = useState([]);
  const [requestingForOptions, setRequestingForOptions] = useState([]);

  const requestingForLabelId = useId();
  const requestingToLabelId = useId();

  // Use media query to determine if drawer mode should be used (for narrow viewports)
  const isMobileWidth = useMediaQuery(`(max-width:${MOBILE_BREAKPOINT}px)`);

  let domainUrl = checkEnvironment().GATEWAY_API_URL;
  const history = useHistory();
  const intl = useIntl();

  const { requestAccessDetails } = useSelector((state) => state.requestHome.initialLoad);

  const getOption = (id) => {
    if (id === 'myself') {
      return {
        label: intl.formatMessage({
          id: 'NewRequestHome.QuickLink.AccessModal.RequestingFor.Myself.Label',
        }),
        id,
      };
    }
    if (id === 'someOneElse') {
      return {
        label: intl.formatMessage({
          id: 'NewRequestHome.QuickLink.AccessModal.RequestingFor.SomeoneElse.Label',
        }),
        id,
      };
    }
    if (id === 'multiplePeople') {
      return {
        label: intl.formatMessage({
          id: 'NewRequestHome.QuickLink.AccessModal.RequestingFor.MultiplePeople.Label',
        }),
        id,
      };
    }
  };

  useEffect(() => {
    if (requestAccessDetails.length > 0) {
      setRequestTiles(requestAccessDetails[0].subMenu);
      const optionsIds = requestAccessDetails.map((option) => option.id);
      const dropdownOptions = Array.from(optionsIds, (val) => getOption(val));
      setRequestingForOptions(dropdownOptions);
    }
  }, [requestAccessDetails]);

  const onOptionChange = (selectedOption) => {
    requestAccessDetails.forEach((option) => {
      if (option.id === selectedOption.id) {
        setRequestTiles(option.subMenu);
      }
    });
  };

  const handleNavigation = (link) => {
    if (link.includes('ECM')) {
      domainUrl = domainUrl.replace(/\/ECMv6/g, '');
      window.location.replace(`${domainUrl}${link}`);
    } else {
      history.push(link);
    }
  };

  const modalTitle = intl.formatMessage({
    id: 'NewRequestHome.QuickLink.AccessModal.Title',
  });

  const closeButtonAriaLabel = intl.formatMessage({ id: 'CloseButton.ariaLabel' });

  const contentBody = (
    <div
      className={classnames(
        'request-access-modal',
        isMobileWidth && 'request-access-modal--mobile'
      )}
    >
      <div className="request-access-modal-header">
        <ButtonIcon
          size="large"
          kind="ghost"
          ariaLabel={closeButtonAriaLabel}
          icon={<Icon kind="Close" />}
          onClick={onDialogClose}
          className="request-access-modal-close-btn"
          dataTestId="closeOwnerModalBtn"
        />
      </div>

      <div className="access-title">
        <StartAccessModal />
        <h2>{modalTitle}</h2>
      </div>
      <div className="requesting-for requestSection-title">
        <p id={requestingForLabelId}>
          {intl.formatMessage({
            id: 'NewRequestHome.QuickLink.AccessModal.RequestingFor.Title',
          })}
        </p>
        <RequestingForDropdown
          username={username}
          options={requestingForOptions}
          onOptionChange={onOptionChange}
          labelId={requestingForLabelId}
        />
      </div>
      <div className="requesting-to requestSection-title">
        <p id={requestingToLabelId}>
          {intl.formatMessage({
            id: 'NewRequestHome.QuickLink.AccessModal.RequestingTo.Title',
          })}
        </p>
        <div
          role="group"
          aria-labelledby={requestingToLabelId}
          className={classnames(
            'request-tiles',
            (requestTiles.length < 3 || !isPamEnabled) && 'request-tiles--hasLessThan3Tiles',
            requestTiles.length === 1 && 'request-tiles--hasOneTile'
          )}
        >
          {requestTiles?.map((item) => {
            if (pamTileId === item.id && !isPamEnabled) {
              return null;
            }

            if (requestTiles.length === 1) {
              return (
                <Button
                  key={item.id}
                  type="button"
                  kind="filled"
                  size="large"
                  className="request-access-start-btn"
                  rightIcon={<Icon kind="ArrowRight" size="medium" color={'neutral-100'} />}
                  isDisabled={!item.isAccessible}
                  onClick={() => {
                    if (item.isAccessible) {
                      handleNavigation(item.link);
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' && item.isAccessible) {
                      handleNavigation(item.link);
                    }
                  }}
                >
                  {getAccessButtonTitle(intl, item.name)}
                </Button>
              );
            }

            return (
              <div
                key={item.id}
                className={`request-tile ${item.isAccessible ? 'active' : 'disabled'}`}
                role="button"
                tabIndex={item.isAccessible ? '0' : '-1'}
                aria-disabled={!item.isAccessible}
                onClick={() => {
                  if (item.isAccessible) {
                    handleNavigation(item.link);
                  }
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' && item.isAccessible) {
                    handleNavigation(item.link);
                  }
                }}
              >
                {renderAccessDetails(intl, item.name, item.isAccessible)}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );

  return (
    <ModalIsland
      isOpen={open}
      isMobileWidth={isMobileWidth}
      isShellMode
      isCloseButtonVisible={false}
      className="request-access-modal-island"
      onClose={onDialogClose}
      contentBody={contentBody}
      mobileDrawerProps={{
        maxHeight: 'calc(100dvh - 4rem)',
        isOpen: open,
        setIsOpen: (isOpen) => {
          if (!isOpen) {
            onDialogClose();
          }
        },
      }}
    />
  );
};

RequestAccessModal.propTypes = {
  onDialogClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
};

export default withRouter(RequestAccessModal);
